
import { Button } from "@/components/ui/button";

const Hero = () => {
  return (
    <section id="home" className="min-h-screen flex items-center relative overflow-hidden pt-20">
      <div className="absolute inset-0 z-0">
        <img 
          src="/lovable-uploads/7a03015c-8263-4d46-94a2-1647d315ab39.png" 
          alt="Hypnose & soins vibratoires pour se réaligner et retrouver sa souveraineté" 
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background/50 to-background"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-20">
        <div className="text-center md:text-left md:w-2/3 lg:w-1/2">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6 animate-fade-in leading-tight">
            🌿 Hypnose & soins vibratoires pour se réaligner et retrouver sa souveraineté et sa lumière
          </h1>
          <h2 className="text-2xl md:text-3xl font-light text-foreground mb-8 animate-fade-in animate-delay-100">
            Un espace pour déposer. Un espace pour renaître.
          </h2>
          <p className="text-lg md:text-xl text-foreground/80 mb-8 animate-fade-in animate-delay-200">
            Séances à Étampes (Essonne – 91) ou en visio partout
          </p>
          <a href="https://calendly.com/meneora" target="_blank" rel="noopener noreferrer">
            <Button className="btn-primary text-lg animate-fade-in animate-delay-300">
              Prendre rendez-vous
            </Button>
          </a>
        </div>
      </div>
      
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <a href="#about" className="text-foreground/60 hover:text-primary transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </a>
      </div>
    </section>
  );
};

export default Hero;
